import { AnnualReportExcelSheet } from './annual-report-excel-sheet.interface';

export interface ExportAnnualReportExcel {
    sheets: AnnualReportExcelSheet[];
}
